var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidAlertOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.35 16.875H11.5H5.65C5.2925 16.875 5 16.5825 5 16.225V14.8405C5 14.535 5.221 14.2945 5.5135 14.21C7.0085 13.781 7.3075 11.9935 7.6 8.42502C7.633 8.0303 7.70623 7.63504 7.82375 7.25574L18 15.8453V16.225C18 16.5825 17.7075 16.875 17.35 16.875ZM16.1808 13.0012L8.24149 6.29973C8.84642 5.27122 9.89431 4.52502 11.5 4.52502C14.1 4.52502 15.2375 6.48152 15.4 8.42502C15.5746 10.5549 15.7492 12.0504 16.1808 13.0012Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 19.475C10.785 19.475 10.2 18.89 10.2 18.175V16.875H12.8V18.175C12.8 18.89 12.215 19.475 11.5 19.475Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63326 5.6667C4.94623 5.29849 5.51046 5.26393 5.89348 5.5895L18.7734 16.5374C19.1564 16.863 19.2132 17.4254 18.9002 17.7936C18.5872 18.1618 18.023 18.1964 17.64 17.8708L4.7601 6.9229C4.37707 6.59732 4.32028 6.0349 4.63326 5.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidAlertOff);
export default __webpack_public_path__ + "static/media/solid-alert-off.1d0d824c96b0177f3d40211d5905d031.svg";
export { ForwardRef as ReactComponent };